export default __webpack_public_path__ + "static/media/white_noise.a32cf163.mp4";